import React from 'react'
import { CssBaseline } from '@mui/material'
import { ThemePreferenceProvider } from '@theme/ThemePreferenceContext'
import { bootstrapStoredThemeAppearance } from '@theme/themeBootstrap'
import ThemeFaviconUpdater from '@theme/ThemeFaviconUpdater'
import './ThemeSwitcher.css'

bootstrapStoredThemeAppearance()

const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemePreferenceProvider>
    <CssBaseline />
    <ThemeFaviconUpdater />
    {children}
  </ThemePreferenceProvider>
)

export default AppThemeProvider
